import script from "./ObjectField.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObjectField.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QTree from 'quasar/src/components/tree/QTree.js';
import qInstall from "../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTree});
